var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeading = function SvgHeading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "heading_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".heading_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.5 15.5-6-13.9c-.1-.3-.4-.4-.7-.3-.1.1-.2.1-.3.3l-6 13.9M7.7 10.5h8.6M4 15.5h3M17 15.5h3M1.5 17.5h21c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1h-21c-.6 0-1-.4-1-1v-4c0-.6.4-1 1-1",
    className: "heading_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17 19.5 2 2 2-2",
    className: "heading_svg__st0"
  })));
};
export default SvgHeading;